module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-mostpopular-2-283200b20e5b543dd3a5351219aa0681.webp";